const CurveDivider = (color: string, borderRadius: number): string => `
    ::before {
        content: "";
        width: ${borderRadius}px;
        height: ${borderRadius * 2}px;
        box-shadow: 0 -${borderRadius}px 0 0 var(${color});
        position: absolute;
        right: -${borderRadius}px;
        border-top-left-radius: ${borderRadius}px;
    }
    
    border-bottom-right-radius: ${borderRadius}px;
`;

export default CurveDivider;
